import { useEffect } from "react";
import { onFirstInteraction } from "@/lib/defer";

// LeadConnector chat widget (floating bubble). The loader pulls in a large
// third-party bundle, so we hold it until the visitor first interacts with the
// page — keeping it off the critical path without changing behaviour for anyone
// who actually uses the site.
const ChatWidget = () => {
  useEffect(() => {
    const load = () => {
      if (document.getElementById("snf-chat-widget")) return;
      const s = document.createElement("script");
      s.id = "snf-chat-widget";
      s.src = "https://widgets.leadconnectorhq.com/loader.js";
      s.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
      s.setAttribute("data-widget-id", "6a6288510c664691c2548dfd");
      s.async = true;
      document.body.appendChild(s);
    };
    return onFirstInteraction(load);
  }, []);

  return null;
};

export default ChatWidget;
